<template>
  <span @click="toggle" :class="{
    'checkbox': true,
    'custom-icon--tick': true,
    'checkbox--checked': value,
    'checkbox--indeterminate': indeterminate,
    'checkbox--enabled': enabled,
    'checkbox--disabled': !enabled,
  }"/>
</template>

<script>
import Vue from 'vue'
import Component from 'vue-class-component'

@Component({
  props: {
    value: {
      required: false,
      type: Boolean,
      default: () => false,
    },
    indeterminate: {
      required: false,
      type: Boolean,
      default: () => false,
    },
    enabled: {
      required: false,
      type: Boolean,
      default: () => true,
    },
  },
})
export default class CheckBox extends Vue {
  toggle () {
    if (!this.enabled) return

    if (this.indeterminate) {
      this.$emit('input', true)
    } else if (this.value) {
      this.$emit('input', false)
    } else {
      this.$emit('input', true)
    }
  }
}
</script>

<style lang="scss" scoped>
.checkbox {
  display: inline-block;
  font-size: 14px;
  cursor: pointer;

  color: #eee;
  background-color: #eee;

  margin: 0;
  padding: 0;

  position: relative;
  width: 1em;
  height: 1em;

  &::before {
    display: block;
    position: absolute;
    top: -5px;
    left: 4px;
  }

  &--checked {
    color: #005ca9;
  }

  &--disabled {
    cursor: initial;
  }

  &--indeterminate {
    color: #888;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/CheckBox.vue